import type { LeadCardHistoryItemData } from '@app/components/LeadCard/data';
import { CHAT_MESSAGE } from '@app/constants';

export interface LeadMessageGroupFlags {
  isFirstInGroup: boolean;
  isLastInGroup: boolean;
}

const STANDALONE: LeadMessageGroupFlags = {
  isFirstInGroup: true,
  isLastInGroup: true,
};

// Ключ отправителя. null — элемент не чат-сообщение: технические записи,
// комментарии и файловые действия LeadMessageItem рендерит отдельными
// компонентами, и группу они разрывают.
const getSenderKey = (item: LeadCardHistoryItemData): string | null => {
  if (item.ActionId !== CHAT_MESSAGE) return null;

  const chatMessage = item.ChatMessages?.[0];

  if (!chatMessage) return null;

  return [
    chatMessage.Direction ?? '',
    String(chatMessage.SocialIntegrationId),
    chatMessage.SenderAccountLogin ?? '',
    chatMessage.IsAiOperator ? 'ai' : '',
    chatMessage.RecommendChat?.origin ?? '',
    chatMessage.RecommendChat?.author.displayName ?? '',
    // У входящих отправитель один — клиент, а UserId бэк заполняет по своей
    // логике, поэтому оператора в ключ берём только для исходящих: два разных
    // оператора подряд должны остаться разными группами.
    chatMessage.Direction === 'out' ? String(chatMessage.UserId) : '',
  ].join('|');
};

// Флаги «первое/последнее в группе» для каждого элемента истории, по позиции.
// Группа — подряд идущие сообщения одного отправителя; по времени не рвём.
export const buildLeadMessageGroupFlags = (
  items: LeadCardHistoryItemData[]
): LeadMessageGroupFlags[] => {
  const senderKeys = items.map(getSenderKey);

  return senderKeys.map((senderKey, index) => {
    if (senderKey === null) return STANDALONE;

    return {
      isFirstInGroup: senderKeys[index - 1] !== senderKey,
      isLastInGroup: senderKeys[index + 1] !== senderKey,
    };
  });
};
